// frontend/src/api/CNAuBIBICFileApi.js (ejemplo)

import api from "./api";

// Obtener todos los archivos
export const fetchCNAuBIBICFiles = async () => {
  try {
    const response = await api.get("/cna-ub-ibic-files/");
    return response.data;
  } catch (error) {
    console.error("Error fetching CNA uB IBIC file records:", error);
    throw error;
  }
};

// Obtener un archivo por ID
export const fetchCNAuBIBICFileById = async (id) => {
  try {
    const response = await api.get(`/cna-ub-ibic-files/${id}/`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching CNA uB IBIC file with ID ${id}:`, error);
    throw error;
  }
};

// Obtener archivos de propuesta
export const listCNAuBIBICFilesByProposal = async (proposalId) => {
  const response = await api.get(`/cna-ub-ibic-files/proposal/${proposalId}/`);
  return response.data;
};

// Buscar archivos por nombre (contiene)
export const searchCNAuBIBICFiles = async (query) => {
  try {
    const response = await api.get(`/cna-ub-ibic-files/?search=${encodeURIComponent(query)}`);
    return response.data;
  } catch (error) {
    console.error(`Error searching CNA uB IBIC files with query "${query}":`, error);
    throw error;
  }
};

// Crear un nuevo archivo
export const createCNAuBIBICFile = async (data) => {
  try {
    const response = await api.post("/cna-ub-ibic-files/", data);
    return response.data;
  } catch (error) {
    console.error("Error creating CNA uB IBIC file:", error);
    throw error;
  }
};

// Actualizar un archivo (solo si es del usuario)
export const updateCNAuBIBICFile = async (id, data) => {
  try {
    const response = await api.put(`/cna-ub-ibic-files/${id}/`, data);
    return response.data;
  } catch (error) {
    console.error(`Error updating CNA uB IBIC file with ID ${id}:`, error);
    throw error;
  }
};

// Eliminar un archivo (solo si es del usuario)
export const softDeleteCNAuBIBICFile = async (id) => {
  try {
    const response = await api.delete(`/cna-ub-ibic-files/${id}/`);
    return response.data;
  } catch (error) {
    console.error("Error soft-deleting CNA uB IBIC files:", error);
    throw error;
  }
};

// Exportar archivos por nombre
/*export const exportCMAMTOFERDAFilesByName = async (namesArray) => {
  try {
    const namesParam = namesArray.map(encodeURIComponent).join(",");
    const response = await api.get(`/cmam-toferda-files/export/?names=${namesParam}`, {
      responseType: "blob",
    });
    return response.data;
  } catch (error) {
    console.error("Error exporting CMAM TOFERDA files by name:", error);
    throw error;
  }
};*/

// Exportar archivos CNA_uB_IBIC_File por ID
export const exportCNAuBIBICFilesById = async (idsArray) => {
  try {
    const idsParam = idsArray.join(",");
    const response = await api.get(`/cna-ub-ibic-files/export/?ids=${idsParam}`, {
      responseType: "blob",
    });
    return response.data;
  } catch (error) {
    console.error("Error exporting CNA uB IBIC file by ID:", error);
    throw error;
  }
};

// Filtros generales
export const filterCNAuBIBICFiles = async (params) => {
  try {
    const query = new URLSearchParams(params).toString();
    const response = await api.get(`/cna-ub-ibic-files/?${query}`);
    return response.data;
  } catch (error) {
    console.error("Error filtering CNA uB IBIC files:", error);
    throw error;
  }
};
